import React, { Fragment, useState, useEffect } from 'react';
import { CSVLink } from 'react-csv';
import WebsiteVisitsChartCard from './WebsiteVisitsChartCard';
import Topic from './Topic';
import Contact from './Contact';
import Recommender from './Recommender';
import Country from './Country';
import ConservationsChartCard from './ConservationsChartCard';
import ChatTimeChartCard from './ChatTimeChartCard';
import Percentage from './Percentage';
import Number from './Number';
import UserQuestions from './UserQuestions';
import MessengerClickStats from './MessengerClickStats';
import NudgesClickStats from './NudgesClickStats';
import MessengerVisitsChartCard from './MessengerVisitsChartCard';
import DatePicker from 'react-datepicker';
import 'moment-timezone';
import visitor from '../../../../../data/visitor';
import {
  Row,
  FormGroup,
  Label,
  Col,
  Card,
  CardBody,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  CardHeader,
  Alert,
} from 'reactstrap';
import Select from 'react-select';
import Axios from 'axios';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { compactFilterSelectStyles } from '../../../../../helpers/reactSelectStyles';
import {
  week,
  month,
  last7Days,
  last30Days,
  last60Days,
  last90Days,
  LastDays,
  year,
} from './lablesConfig';
import moment from 'moment';
import IntlMessages from '../../../../../helpers/IntlMessages';
import { faLock, faLockOpen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  gAPI_BookingEngineSearch_List,
  gAPI_VisitorsGroups_Stats,
  gAPI_Topics_Stats,
  gAPI_Percentage_Stats,
  gAPI_Conversations_Stats,
  gAPI_Conversations_Night_Stats,
  API_CountriesGroups_Stats,
  gAPI_Conversations_VisitorQuestions,
  gAPI_Conversations_Stats_Year,
  gAPI_Conversations_Night_Year_Stats,
  gAPI_VisitorsGroupsMonth_Stats,
  gAPI_Number_Stats,
  gAPI_Conversations_Time_Stats,
  gAPI_Conversations_Night_Time_Stats,
  gAPI_Conversations_Time_Year_Stats,
  gAPI_Conversations_Night_Year_Time_Stats,
  gAPI_Recommender_Stats,
  gAPI_VisitorsGroupsContact_Stats,
  gAPI_TicketGroup_Stats,
  gAPI_Ticket_Stats_ByCategory,
  gAPI_BookingEngineSearch_Stats,
  API_Ingetration_Channels,
  gAPI_Messenger_Click,
  gAPI_Nudges_Click,
  gAPI_Messenger_DateWiseStats,
  gAPI_Internal_Property_List,
  gAPI_AvatarClick_Stats,
  gAPI_AllPropertyStatsSummary,
  gAPI_Messenger_TopClickedUrls,
  gAPI_Language_DistributionStats,
} from '../../../../../constants/APIs';
import VoucherClicks from './VoucherClicks';
import VoucherEngineSales from './VoucherEngineSales';
import PopularVoucher from './PopularVoucher';
import RecentOrder from './RecentOrder';
import VoucherEngineVisits from './VoucherEngineVisits';
import topic from '../../../../../data/topic';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import TicketStatsByCategory from './TicketStatsByCategory';
import NumberTotalConversation from './NumberTotalConversation';
import SubscribeToReports from './SubscribeToReports';
import { injectIntl } from 'react-intl';
import TopClickedUrls from './TopClickedUrls';
import { addOneDay } from '../../../../../helpers/Utils';
import LanguageDistributionStats from './LanguageDistributionStats';
const dataTableColumnsContacts = [
  {
    Header: <IntlMessages id="dashboards.name" />,
    accessor: 'name',
    Cell: (props) => <p className="">{props.value}</p>,
  },
  {
    Header: 'Email',
    accessor: 'email',
    Cell: (props) => <p className="">{props.value}</p>,
  },
  {
    Header: 'Phone',
    accessor: 'phone',
    Cell: (props) => <p className="">{props.value}</p>,
  },
  {
    Header: 'Zip Code',
    accessor: 'zipCode',
    Cell: (props) => <p className="">{props.value}</p>,
  },
  {
    Header: <IntlMessages id="dashboards.marketingconsent" />,
    accessor: 'consent',
    Cell: (props) => <p className="">{props.value}</p>,
  },
  {
    Header: 'Date',
    accessor: 'consentDate',
    Cell: (props) => (
      <p className="">
        {props.value !== '' ? moment(props.value).format('lll') : ''}
      </p>
    ),
  },
];

const dataTableRecommenderColumns = [
  {
    Header: <IntlMessages id="dashboards.name" />,
    accessor: 'name',
    Cell: (props) => <p className="ml-2">{props.value}</p>,
  },
  {
    Header: <IntlMessages id="dashboards.button" />,
    accessor: 'button',
    Cell: (props) => <p className="ml-3">{props.value}</p>,
  },
  {
    Header: <IntlMessages id="dashboards.visits" />,
    accessor: 'visits',
    Cell: (props) => <p className="ml-4">{props.value}</p>,
  },
];
const TitleCellWithIntlMessages = ({ value }) => {
  let messageId = '';

  switch (value) {
    case 'Group Booking':
      messageId = 'dashboards.groupBooking';
      break;
    case 'Start a Chat':
      messageId = 'dashboards.startChat';
      break;
    case 'Lost Something':
      messageId = 'dashboards.lostsomething';
      break;
    case 'Table Booking':
      messageId = 'dashboard.tablebooking';
      break;
    case 'Booking Room New':
      messageId = 'dashboards.bookingroomnew';
      break;
    case 'Rooms, Availability & Rates':
      messageId = 'dashboards.roomsAvailability';
      break;
    case 'Promotions':
      messageId = 'dashboards.promotions';
      break;
    case 'Wedding & Events':
      messageId = 'dashboards.weedingevents';
      break;
    case 'Product Text':
      messageId = 'dashboards.producttext';
      break;
    case 'Restaurants & Bars':
      messageId = 'dashboards.restaurantsBars';
      break;
    case 'Rooms & Availability':
      messageId = 'dashboards.roomsAvailability';
      break;
    case 'Events & Wedding Venues':
      messageId = 'dashboards.events-wedding-venues';
      break;
    case 'Long Stay Enquiry':
      messageId = 'dashboards.long-stay-enquiry';
      break;
    case 'Reservation Confirmation Request':
      messageId = 'dashboards.reservation-confirmation-request';
      break;
    case 'Modify or Cancel Booking':
      messageId = 'dashboards.modify-cancel-booking';
      break;
    case 'Left Something Behind':
      messageId = 'dashboards.left-something-behind';
      break;
    case 'Invoice/Receipt Copy':
      messageId = 'dashboards.invoice-copy';
      break;
    default:
      messageId = null;
  }

  return (
    <p className="ml-2">
      {messageId ? <IntlMessages id={messageId} /> : value}
    </p>
  );
};

const dataTableMessengerColumns = [
  {
    Header: <IntlMessages id="dashboards.title" />,
    accessor: 'title',
    Cell: TitleCellWithIntlMessages,
  },
  {
    Header: <IntlMessages id="dashboards.clicks" />,
    accessor: 'clicks',
    Cell: (props) => <p className="ml-3">{props.value}</p>,
  },
];

const dataTableNudgesColumns = [
  {
    Header: <IntlMessages id="dashboards.title" />,
    accessor: 'title',
    Cell: TitleCellWithIntlMessages,
  },
  {
    Header: <IntlMessages id="dashboards.clicks" />,
    accessor: 'clicks',
    Cell: (props) => <p className="ml-3">{props.value}</p>,
  },
];

const countryDataTableColumns = [
  {
    Header: <IntlMessages id="dashboards.country" />,
    accessor: 'country',
    Cell: (props) => <p className="ml-2">{props.value}</p>,
  },
  {
    Header: <IntlMessages id="dashboards.webVisitors" />,
    accessor: 'visitors',
    Cell: (props) => <p className="ml-5">{props.value}</p>,
  },
  // {
  //   Header: 'Avatar Clicks',
  //   accessor: 'messengerClicks',
  //   Cell: (props) => <p className="ml-5">{props.value}</p>,
  // },
  {
    Header: <IntlMessages id="dashboards.avatarClicks" />,
    accessor: 'botClicks',
    Cell: (props) => <p className="ml-5">{props.value}</p>,
  },
  {
    Header: <IntlMessages id="menu.conversations" />,
    accessor: 'conversations',
    Cell: (props) => <p className="ml-5">{props.value}</p>,
  },
];
const voucherEngineVisits = [
  {
    Header: 'Country',
    accessor: 'country',
    Cell: (props) => <p className="">{props.value}</p>,
  },
  {
    Header: 'Clicks',
    accessor: 'clicks',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
  {
    Header: 'Visitors',
    accessor: 'visitors',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
];
const poupularVoucherDataTablescolumn = [
  {
    Header: 'Name',
    accessor: 'voucherName',
    Cell: (props) => <p>{props.value}</p>,
  },
  {
    Header: 'Views',
    accessor: 'views',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
  {
    Header: 'Added to Cart',
    accessor: 'cart',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
  {
    Header: 'Payments',
    accessor: 'payments',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
  {
    Header: 'Purchases',
    accessor: 'purchases',
    Cell: (props) => (
      <p className="popular-voucher" style={{ marginLeft: '2rem!important' }}>
        {props.value}
      </p>
    ),
  },
];
function ChartCard({
  propertyId,
  isVoucherEngine,
  timeZone,
  domains,
  currency,
  history,
  integrationIdList,
  intl,
}) {
  moment.tz.setDefault(timeZone);
  const [buttonText, setButtonText] = useState(
    <IntlMessages id="dashboards.last-7-days" />
  );
  const [labels, setLabels] = useState(last7Days);
  const [visitorStatsData, setVisitorStatsData] = useState([]);
  const [topicsStatsData, setTopicsStatsData] = useState([]);
  const [contactStatsData, setContactStatsData] = useState([]);
  const [recommenderStatsData, setRecommenderStatsData] = useState([]);
  const [percentageStatsData, setPercentageStatsData] = useState([]);
  const [numberStatsData, setNumberStatsData] = useState([]);
  const [countriesStatsData, setCountriesStatsData] = useState([]);
  const [visitorQuestionsData, setvisitorQuestions] = useState([]);
  const [allVisitorQuestionsData, setAllVisitorQuestionsData] = useState([]);
  const [conversationStatsData, setConversationStatsData] = useState([]);
  const [conversationNightStatsData, setConversationNightStatsData] = useState(
    []
  );
  const [chattimeStatsData, setChatTimeStatsData] = useState([]);
  const [chattimeNightStatsData, setChatTimeNightStatsData] = useState([]);
  const [bookingEngineSearchData, setBookingEngineSearchData] = useState([]);
  const [messengerClickData, setMessengerClickData] = useState([]);
  const [nudgesClickData, setNudgesClickData] = useState([]);
  const [messengerVisitStatsData, setMessengerVisitStatsData] = useState([]);
  const [ticketByCategoryData, setTicketByCategoryData] = useState([]);
  const [avatarClicksData, setAvatarClicksData] = useState([]);
  const [visitorQuestionsPageSize, setvisitorQuestionsPageSize] = useState(20);
  const [visitorQuestionsPageNumber, setvisitorQuestionsNumber] = useState(1);
  const [fromDate, setfromDate] = useState('');
  const [toDate, settoDate] = useState('');
  const [isloading, setLoading] = useState(true);
  const [isWebsiteVisit, setIsWebsiteVisit] = useState(true);
  const [isConversationGraph, setIsConversationGraph] = useState(true);
  const [isTopics, setTopics] = useState(true);
  const [isContact, setContacts] = useState(true);
  const [isRecommender, setRecommender] = useState(true);
  const [isCountry, setIsCountry] = useState(true);
  const [isChatEngagement, setIsChatEngagement] = useState(true);
  const [isPercentage, setIsPercentage] = useState(true);
  const [isUserQuestion, setIsUserQuestion] = useState(true);
  const [isChatTime, setIsChatTime] = useState(true);
  const [isTotalTicket, setIsTotalTicket] = useState(true);
  const [isMessengerStats, setIsMessengerStats] = useState(true);
  const [isNudgesStats, setIsNudgesStats] = useState(true);
  const [isMessengerVisitStats, setIsMessengerVisitStats] = useState(true);
  const [isTicketByCategory, setIsTicketByCategory] = useState(true);
  const [clicks, setClicks] = useState([]);
  const [isclicks, setIsClicks] = useState(true);
  const [sales, setSales] = useState([]);
  const [isSales, setIsSales] = useState(true);
  const [stats, setStats] = useState([]);
  const [isStats, setIsStats] = useState(true);
  const [statsData, setStatsData] = useState([]);
  const [countryvisit, setCountryVisit] = useState([]);
  const [isCountryStats, setIsCountryStats] = useState(true);
  const [totalTicketStats, setTotalTicketStats] = useState([]);
  const [isBookingEngineConnect, setIsBookingEngineConnect] = useState(false);
  const [isMessengerConnect, setIsMessengerConnect] = useState(false);
  // const [propertyLoaded, setpropertyLoaded] = useState(propertyId);
  const [isMasked, setIsMasked] = useState(sessionStorage.getItem('lock'));
  const [selectedDateRangeOption, setSelectedDateRangeOption] =
    useState('last_7_days');

  const [isShow, setIsShow] = useState(false);
  const [isError, setError] = useState(false);
  const [message, setMessage] = useState('');
  const [filterDate, setFilterDate] = useState(false);
  const [startDate, setStartDate] = useState(moment().subtract(15, 'days'));
  const [endDate, setEndDate] = useState(moment().subtract(1, 'days'));
  const [propertyData, setPropertyData] = useState(null);
  const [isBusinessOperator, setIsBusinessOperator] = useState(false);
  const [isUtilityProvider, setIsUtilityProvider] = useState(false);
  const [hideWebwidgetStats, setHideWebwidgetStats] = useState(false);
  const [csvData, setCSVData] = useState([]);
  const [topicsError, setTopicsError] = useState(null);
  const [countriesError, setCountriesError] = useState(null);
  const [recommenderError, setRecommenderError] = useState(null);
  const [contactError, setContactError] = useState(null);
  const [percentageError, setPercentageError] = useState(null);
  const [numberStatsError, setNumberStatsError] = useState(null);
  const [visitorStatsError, setVisitorStatsError] = useState(null);
  const [conversationStatsError, setConversationStatsError] = useState(null);
  const [avatarClicksError, setAvatarClicksError] = useState(null);
  const [chatTimeStatsError, setChatTimeStatsError] = useState(null);
  const [chatTimeNightError, setChatTimeNightError] = useState(null);
  const [conversationNightError, setConversationNightError] = useState(null);
  const [visitorQuestionsError, setVisitorQuestionsError] = useState(null);
  const [ticketStatsError, setTicketStatsError] = useState(null);
  const [bookingSearchError, setBookingSearchError] = useState(null);
  const [messengerClicksError, setMessengerClicksError] = useState(null);
  const [nudgesClicksError, setNudgesClicksError] = useState(null);
  const [messengerVisitStatsError, setMessengerVisitStatsError] =
    useState(null);
  const [ticketByCategoryError, setTicketByCategoryError] = useState(null);
  const [bookingCsvData, setBookingCsvData] = useState([]);
  const [topClickedUrlsData, setTopClickedUrlsData] = useState([]);
  const [isTopClickedUrls, setIsTopClickedUrls] = useState(true);
  const [topClickedUrlsError, setTopClickedUrlsError] = useState(null);
  const [totalClicks, setTotalClicks] = useState(0);
  const [languageDistribution, setLanguageDistribution] = useState(null);
  const [isLanguageDistribution, setIsLanguageDistribution] = useState(true);
  const [languageDistributionError, setLanguageDistributionError] =
    useState(null);

  useEffect(() => {
    // console.log('from', fromDate, toDate, propertyId)
    if (fromDate !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_BookingEngineSearch_List}?groupId=${getGroupID()}&propertyId=${propertyId}&dateFrom=${fromDate}&dateTo=${toDate}`,
      }).then((res) => {
        var tablePrint = [
          {
            r1: 'Booking Engine Data',
            r2: '',
            r3: '',
            r4: '',
            r5: '',
            r6: '',
            r7: '',
            r8: '',
          },
          {
            r1:
              'Start Date :' +
              moment(fromDate).format('DD') +
              '/' +
              moment(fromDate).format('MM') +
              '/' +
              moment(fromDate).format('YYYY'),
            r2: '',
            r3:
              'End Date :' +
              moment(toDate).format('DD') +
              '/' +
              moment(toDate).format('MM') +
              '/' +
              moment(toDate).format('YYYY'),
            r4: '',
            r5: '',
            r6: '',
            r7: '',
            r8: '',
          },
          {},
          {
            r1: 'Check-In Date',
            r2: 'Check-Out Date',
            r3: 'Nights',
            r4: 'Adults',
            r5: 'Childrens',
            r6: 'Promo Code',
            r7: 'Conversation Date',
            r8: 'Average Revenue',
          },
        ];
        if (res.data.length > 0 && res.data.length > 0) {
          res.data.map((elem) => {
            tablePrint.push({
              r1: elem.checkInDate,
              r2: elem.checkOutDate,
              r3: elem.nights,
              r4: elem.adults,
              r5: elem.childrens,
              r6: elem.promoCode,
              r7:
                moment(elem.createdDate).format('DD') +
                '/' +
                moment(elem.createdDate).format('MM') +
                '/' +
                moment(elem.createdDate).format('YYYY'),
              r8: elem.currency + ' ' + elem.revenue,
            });
          });
        }
        setBookingCsvData(tablePrint);
      });
    }
  }, [fromDate, toDate, propertyId]);

  const StatContainer = ({ onRefresh, error, children }) => {
    return (
      <div>
        {error ? (
          <Card className="text-center my-3" style={{ padding: '100px' }}>
            <p style={{ color: 'red' }}>{error}</p>

            <i
              className="iconsminds-refresh"
              style={{ fontSize: '40px', color: 'grey' }}
              onClick={onRefresh}
            />
          </Card>
        ) : (
          children
        )}
      </div>
    );
  };

  const maskEmail = (text) => {
    if (text !== null && text !== undefined) {
      let maskedvalue = text.replace(/()(.*)(?=@)/, function (gp1, gp2, gp3) {
        for (let i = 0; i < gp3.length; i++) {
          gp2 += 'X';
        }
        return gp2;
      });
      return maskedvalue;
    } else return '';
  };
  const maskMobile = (text, number) => {
    if (text !== null && text !== undefined) {
      let maskedValue = '';
      for (let i = 0; i < text.length - number; i++) {
        maskedValue += 'X';
      }
      return maskedValue + text.substring(text.length - number, text.length);
    } else return '';
  };
  const dataTableColumnsContacts = [
    {
      Header: <IntlMessages id="dashboards.name" />,
      accessor: 'name',
      Cell: (props) => <p className="">{props.value}</p>,
    },
    {
      Header: <IntlMessages id="dashboards.email" />,
      accessor: 'email',
      Cell: (props) => (
        <p className="">
          {isMasked !== 'true' ? maskEmail(props.value) : props.value}
          <span
            className="text-muted ml-1"
            style={{ cursor: 'pointer', position: 'absolute' }}
            onClick={handleMaskClick}
          >
            {props.value !== '' && (
              <FontAwesomeIcon
                icon={isMasked === 'true' ? faLockOpen : faLock}
                className="fa"
              />
            )}
          </span>
        </p>
      ),
    },
    {
      Header: <IntlMessages id="dashboards.phone" />,
      accessor: 'phone',
      Cell: (props) => (
        <p className="ml-3">
          {isMasked !== 'true' ? maskMobile(props.value, 4) : props.value}
          <span
            className="text-muted ml-1"
            style={{ cursor: 'pointer' }}
            onClick={handleMaskClick}
          >
            {props.value !== '' && (
              <FontAwesomeIcon
                icon={isMasked === 'true' ? faLockOpen : faLock}
                className="fa"
              />
            )}
          </span>
        </p>
      ),
    },
    {
      Header: <IntlMessages id="dashboards.zipcode" />,
      accessor: 'zipCode',
      Cell: (props) => <p className="">{props.value}</p>,
    },
    {
      Header: <IntlMessages id="dashboards.marketingconsent" />,
      accessor: 'consent',
      Cell: (props) => <p className="">{props.value}</p>,
    },
    {
      Header: <IntlMessages id="dashboards.additionalinfo" />,
      accessor: 'additionalInfo',
      Cell: (props) =>
        props.value !== undefined &&
        props.value !== null && (
          <p className="">
            {props.value.groupName !== null && props.value.groupName !== '' && (
              <p className="mb-0 ">{props.value.groupName}</p>
            )}
            {props.value.businessName !== null &&
              props.value.businessName !== '' && (
                <p className="mb-0 ">{props.value.businessName}</p>
              )}
            {props.value.propertyName !== null &&
              props.value.propertyName !== '' && (
                <p className="mb-0 ">{props.value.propertyName}</p>
              )}
            {props.value.chainName !== null && props.value.chainName !== '' && (
              <p className="mb-0 ">{props.value.chainName}</p>
            )}
            {props.value.userType !== null && props.value.userType !== '' && (
              <p className="mb-0 ">{props.value.userType}</p>
            )}
          </p>
        ),
    },
    {
      Header: <IntlMessages id="forms.date" />,
      accessor: 'consentDate',
      Cell: (props) => (
        <p className="">
          {props.value !== '' ? moment(props.value).format('lll') : ''}
        </p>
      ),
    },
  ];

  const dataTableTicketByCategoryColumns = [
    {
      Header: <IntlMessages id="dashboards.category" />,
      accessor: 'category',
      Cell: (props) => (
        <p className="ml-2">
          <a
            className="btn-link"
            style={{ textDecoration: 'underline' }}
            onClick={() => handleNavigateToTicket(props.value)}
          >
            {props.value}
          </a>
        </p>
      ),
    },
    {
      Header: <IntlMessages id="dashboards.ticket-count" />,
      accessor: 'ticketCount',
      Cell: (props) => <p className="ml-3">{props.value}</p>,
    },
  ];
  const dataTableTopClickedUrlsColumns = [
    {
      Header: <IntlMessages id="dashboards.urls" />,
      accessor: 'url',
      Cell: (props) => {
        const rawUrl = props.value || '';
        const safeUrl = /^https?:\/\//i.test(rawUrl)
          ? rawUrl
          : `https://${rawUrl}`;

        return (
          <p className="ml-2">
            <a href={safeUrl} target="_blank" rel="noopener noreferrer">
              {props.value}
            </a>
          </p>
        );
      },
    },
    {
      Header: <IntlMessages id="dashboards.clicks" />,
      accessor: 'clicks',
      Cell: (props) => <p className="ml-3">{props.value}</p>,
    },
  ];
  const handleNavigateToTicket = (value) => {
    history.push({
      pathname: '/app/pages/agent-assist',
      state: { categoryvalue: value },
    });
  };

  const handleMaskClick = () => {
    if (isMasked === 'true') {
      sessionStorage.setItem('lock', 'false');
      setIsMasked(sessionStorage.getItem('lock'));
    } else {
      sessionStorage.setItem('lock', 'true');
      setIsMasked(sessionStorage.getItem('lock'));
    }
  };
  const handlenavbooking = (value) => {
    history.push({
      pathname: '/app/pages/agent-assist',
      state: { tagName: value },
    });
  };
  const dataTableColumns = [
    {
      Header: <IntlMessages id="content.topics" />,
      accessor: 'topic',
      Cell: (props) => (
        <p className="ml-2">
          {topic?.filter((e) => e.topic === props.value).length > 0 ? (
            <a
              className="btn-link"
              style={{ textDecoration: 'underline' }}
              onClick={() => handlenavbooking(props.value)}
            >
              {props.value}
            </a>
          ) : (
            props.value
          )}
        </p>
      ),
    },
    {
      Header: <IntlMessages id="menu.conversations" />,
      accessor: 'conversations',
      Cell: (props) => <p className="ml-5">{props.value}</p>,
    },
    {
      Header: <IntlMessages id="chat.messages" />,
      accessor: 'messages',
      Cell: (props) => <p className="ml-5">{props.value}</p>,
    },
  ];
  const dataTableColumnsAnalyze = [
    {
      Header: <IntlMessages id="content.topics" />,
      accessor: 'topic',
      Cell: (props) => <p className="ml-2">{props.value}</p>,
    },
    {
      Header: <IntlMessages id="menu.conversations" />,
      accessor: 'conversations',
      Cell: (props) => <p className="ml-5">{props.value}</p>,
    },
  ];

  useEffect(() => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Internal_Property_List}?group_id=${getGroupID()}`,
    }).then((res) => {
      var allproperties = res.data;
      var isLocal = false;
      if (propertyId === '-1') {
        var totalwageRate = 0;
        var totalwageRateUSD = 0;
        var currency = '';
        var currencyProperty = allproperties?.filter(
          (n) => n.currency !== null && n.currency !== ''
        );
        const allEqual = currencyProperty.every(
          (val) => val === currencyProperty[0]
        );
        if (allproperties.length === currencyProperty.length) {
          if (allEqual) {
            currency = currencyProperty[0].currency;
          } else {
            currency = 'USD';
          }
        }
        var hourly = allproperties?.filter(
          (n) =>
            n.averageHourlyWageRate !== null && n.averageHourlyWageRate !== 0
        );
        if (allproperties.length === hourly.length) {
          totalwageRate = hourly[0].averageHourlyWageRate;
        }
        var hourlyUSD = allproperties?.filter(
          (n) =>
            n.averageHourlyWageRateUSD !== null &&
            n.averageHourlyWageRateUSD !== 0
        );
        if (allproperties.length === hourlyUSD.length) {
          totalwageRateUSD = hourlyUSD[0].averageHourlyWageRateUSD;
        }
        // var propertyList = allproperties.filter(n => n.currency !== null && n.currency !== "");
        // propertyList.map(x => {
        //   if (propertyList.length > 0) {
        //     currency = propertyList[0].currency;
        //     isLocal = true;
        //   }
        //   totalwageRate = totalwageRate + x.averageHourlyWageRate;
        //   totalwageRateUSD = totalwageRate + x.averageHourlyWageRateUSD;
        // });
        var body = {
          currency: currency,
          totalwageRate: totalwageRate,
          totalwageRateUSD: totalwageRateUSD,
          isLocal: isLocal,
          isGroupLevel: true,
          analyzeTicket: false,
        };
        setPropertyData(body);
      } else {
        var propertydata = allproperties?.filter((m) => m.id == propertyId);
        if (propertydata !== null && propertydata.length > 0) {
          if (propertydata[0].hideStats !== null) {
            setHideWebwidgetStats(propertydata[0].hideStats.hideWebWidget);
          }
          var totalwageRate = propertydata[0].averageHourlyWageRate;
          var totalwageRateUSD = propertydata[0].averageHourlyWageRateUSD;
          var currency = propertydata[0].currency;
          var body = {
            currency: currency,
            totalwageRate: totalwageRate,
            totalwageRateUSD: totalwageRateUSD,
            isLocal: isLocal,
            isGroupLevel: false,
            analyzeTicket: propertydata[0].analyzeTicket,
          };
          setPropertyData(body);
        }
      }
    });

    selectLast7Days();
    let body = {
      channels: ['BookingEngineUrl', 'HelpCenter', 'HelpCenterGroup'],
    };
    AxiosAPI({
      method: 'post',
      url: `${API_Ingetration_Channels}?group_id=${getGroupID()}`,
      data: body,
    }).then((res) => {
      var getBookingEngine = res.data.filter(
        (i) => i.channel === 'BookingEngineUrl' && i.disabled !== true
      );
      if (getBookingEngine.length > 0) {
        if (propertyId !== '-1') {
          var channel = getBookingEngine?.filter(
            (i) => i.propertyId === propertyId
          );
          if (channel.length > 0) {
            setIsBookingEngineConnect(true);
          }
        }
      }
      var helpcenter = res.data.filter(
        (i) => i.channel === 'HelpCenter' && i.disabled !== true
      );
      if (helpcenter.length > 0) {
        if (propertyId !== '-1') {
          if (
            helpcenter.filter((i) => i.properties.includes(propertyId)).length >
            0
          ) {
            setIsMessengerConnect(true);
          }
        }
      }
      var helpcentergroup = res.data.filter(
        (i) => i.channel === 'HelpCenterGroup' && i.disabled !== true
      );
      if (helpcentergroup.length > 0) {
        setIsMessengerConnect(true);
      }

      if (propertyId === '-1') {
        var helpcenter = res.data.filter(
          (i) => i.channel === 'HelpCenter' && i.disabled !== true
        );
        if (helpcenter.length > 0) {
          setIsMessengerConnect(true);
        }
      }
    });
  }, [propertyId]);

  const today = () => {
    return moment(
      moment().subtract(1, 'days').format('YYYY-MM-DD') + ' 23:59:59'
    )
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  const daysAgo7 = () => {
    return moment(moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss'))
      .utc()
      .format('YYYY-MM-DD 00:00:00');
  };

  const daysAgo30 = () => {
    return moment(moment().subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss'))
      .utc()
      .format('YYYY-MM-DD 00:00:00');
  };

  const daysAgo60 = () => {
    return moment(moment().subtract(60, 'days').format('YYYY-MM-DD HH:mm:ss'))
      .utc()
      .format('YYYY-MM-DD 00:00:00');
  };

  const daysAgo90 = () => {
    return moment(moment().subtract(90, 'days').format('YYYY-MM-DD HH:mm:ss'))
      .utc()
      .format('YYYY-MM-DD 00:00:00');
  };

  const startOfWeek = () => {
    const today = moment().subtract(1, 'days');
    return moment(moment(today).isoWeekday(1).format('YYYY-MM-DD HH:mm:ss'))
      .utc()
      .format('YYYY-MM-DD 00:00:00');
  };

  const endOfWeek = () => {
    const today = moment().subtract(1, 'days');
    return moment(
      moment(today).isoWeekday(7).format('YYYY-MM-DD') + ' 23:59:59'
    )
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  const startOfMonth = () => {
    return moment(moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'))
      .utc()
      .format('YYYY-MM-DD 00:00:00');
  };

  const startOfPreviousMonth = () => {
    return moment(
      moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD') +
      ' 00:00:00'
    )
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  const startOfThisYear = () => {
    return moment(new Date().getFullYear() + '-01-01' + ' 00:00:00').format(
      'YYYY-MM-DD HH:mm:ss'
    );
  };

  const startOfLastYear = () => {
    return moment(new Date().getFullYear() - 1 + '-01-01' + ' 00:00:00').format(
      'YYYY-MM-DD HH:mm:ss'
    );
  };
  const endOfLastYear = () => {
    return moment(new Date().getFullYear() - 1 + '-12-31' + ' 00:00:00').format(
      'YYYY-MM-DD HH:mm:ss'
    );
  };

  const endOfPreviousMonth = () => {
    return moment(
      moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD') +
      ' 23:59:59'
    )
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };
  const loadMore = () => {
    const currentPage = visitorQuestionsPageNumber + 1;
    setvisitorQuestionsNumber(currentPage);
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Conversations_VisitorQuestions}`,
      params: {
        groupId: getGroupID(),
        dateFrom: fromDate,
        dateTo: toDate,
        pageNumber: currentPage,
        pageSize: visitorQuestionsPageSize,
        propertyId: propertyId,
      },
    }).then((res) => {
      setLoading(true);
      // console.log('res', res.data)
      const data = [...visitorQuestionsData, ...res.data?.messagesList];
      setvisitorQuestions(data);
    });
  };

  const endOfMonth = () => {
    return moment(moment().endOf('month').format('YYYY-MM-DD') + ' 23:59:59')
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  };

  const handleStartDate = (date) => {
    setStartDate(date);
  };

  const handleEndDate = (date) => {
    setEndDate(date);
  };

  //seperate function for each api
  const fetchLanguaageDistributionStats = async (from, to) => {
    try {
      setLanguageDistributionError(null);
      const res = await AxiosAPI({
        method: 'get',
        url: gAPI_Language_DistributionStats, // ← replace with your actual endpoint
        params: {
          groupId: getGroupID(),
          dateFrom: from,
          dateTo: to,
          propertyId,
        },
      });
      console.log(1067, res?.data);
      setLanguageDistribution(res?.data.langaugeStats);
      setIsLanguageDistribution(false);
    } catch (err) {
      setLanguageDistributionError('Failed to load top clicked URLs.');
      setIsLanguageDistribution(false);
    }
  };

  const fetchTopClickedUrls = async (from, to) => {
    try {
      setTopClickedUrlsError(null);
      const res = await AxiosAPI({
        method: 'get',
        url: gAPI_Messenger_TopClickedUrls, // ← replace with your actual endpoint
        params: {
          groupId: getGroupID(),
          dateFrom: from,
          dateTo: to,
          propertyId,
          type: 3,
        },
      });
      const formatted = Array.isArray(res?.data)
        ? res.data.map((item) => ({
          url: item.url,
          clicks: item.clicks,
        }))
        : [];
      setTopClickedUrlsData(formatted);
      setIsTopClickedUrls(false);
    } catch (err) {
      setTopClickedUrlsError('Failed to load top clicked URLs.');
      setIsTopClickedUrls(false);
    }
  };

  const fetchTopicsStats = async (from, to) => {
    setTopicsError(null);
    try {
      const res = await AxiosAPI({
        method: 'get',
        url: gAPI_Topics_Stats,
        params: {
          groupId: getGroupID(),
          dateFrom: from,
          dateTo: to,
          propertyId,
        },
      });
      const data = Array.isArray(res.data) ? res.data : [];
      setTopicsStatsData(data);
      setTopics(false);
    } catch (err) {
      setTopicsError('Failed to load topics data.');
      setTopics(false);
    }
  };

  const fetchCountriesStats = async (from, to) => {
    try {
      setCountriesError(null);
      const res = await AxiosAPI({
        method: 'post',
        url: API_CountriesGroups_Stats,
        data: {
          groupId: getGroupID(),
          dateFrom: from,
          dateTo: to,
          propertyId,
          integrationIds: integrationIdList,
        },
      });

      const data = res?.data || [];
      setCountriesStatsData(data);
      const totalBotClicks = data.reduce(
        (sum, item) => sum + (item.botClicks || 0),
        0
      );
      setTotalClicks(totalBotClicks);
      setIsCountry(false);
    } catch (err) {
      setCountriesError('Failed to load countries data.');
      setIsCountry(false);
    }
  };

  const fetchRecommenderStats = async (from, to) => {
    try {
      setRecommenderError(null);
      const res = await AxiosAPI({
        method: 'get',
        url: gAPI_Recommender_Stats,
        params: {
          groupId: getGroupID(),
          dateFrom: from,
          dateTo: to,
          propertyId,
        },
      });
      setRecommenderStatsData(res?.data);
      setRecommender(false);
    } catch (err) {
      setRecommenderError('Failed to load recommender data.');
      setRecommender(false);
    }
  };

  const fetchContactStats = async (from, to) => {
    try {
      setContactError(null);
      const res = await AxiosAPI({
        method: 'get',
        url: gAPI_VisitorsGroupsContact_Stats,
        params: {
          groupId: getGroupID(),
          dateFrom: from,
          dateTo: to,
          propertyId,
        },
      });
      setContactStatsData(res?.data);
      setContacts(false);
    } catch (err) {
      setContactError('Failed to load contact stats.');
      setContacts(false);
    }
  };

  const fetchPercentageStats = async (from, to) => {
    try {
      setPercentageError(null);
      const res = await AxiosAPI({
        method: 'get',
        url: gAPI_Percentage_Stats,
        params: {
          groupId: getGroupID(),
          dateFrom: from,
          dateTo: to,
          propertyId,
        },
      });
      setPercentageStatsData(res?.data);
      setIsPercentage(false);
    } catch (err) {
      setPercentageError('Failed to load percentage stats.');
      setIsPercentage(false);
    }
  };

  const fetchNumberStats = async (from, to) => {
    try {
      setNumberStatsError(null);
      const res = await AxiosAPI({
        method: 'get',
        url: gAPI_Number_Stats,
        params: {
          groupId: getGroupID(),
          dateFrom: from,
          dateTo: to,
          propertyId,
        },
      });
      setNumberStatsData(res?.data);
      setIsChatTime(false);
    } catch (err) {
      setNumberStatsError('Failed to load number stats.');
      setIsChatTime(false);
    }
  };

  const fetchVisitorStats = async (from, to) => {
    try {
      setVisitorStatsError(null);
      const res = await AxiosAPI({
        method: 'post',
        url: gAPI_VisitorsGroups_Stats,
        data: {
          groupId: getGroupID(),
          dateFrom: from,
          dateTo: to,
          propertyId: propertyId === '-1' ? null : propertyId,
          integrationId: integrationIdList,
        },
      });
      setVisitorStatsData(res?.data);
      setIsWebsiteVisit(false);
    } catch (err) {
      setVisitorStatsError('Failed to load visitor stats.');
      setIsWebsiteVisit(false);
    }
  };
  const fetchVisitorsGroupMonthStats = async (from, to) => {
    try {
      setVisitorStatsError(null);
      const res = await AxiosAPI({
        method: 'post',
        url: `${gAPI_VisitorsGroupsMonth_Stats}`,
        data: {
          groupId: getGroupID(),
          dateFrom: from,
          dateTo: to,
          propertyId: propertyId === '-1' ? null : propertyId,
          integrationId: integrationIdList,
        },
      });
      // console.log('3334', res?.data);
      setVisitorStatsData(res?.data);
      setIsWebsiteVisit(false);
    } catch (err) {
      setVisitorStatsError('Failed to load visitor stats.');
      setIsWebsiteVisit(false);
    }
  };

  const fetchConversationStats = async (from, to) => {
    try {
      setConversationStatsError(null);
      const res = await AxiosAPI({
        method: 'get',
        url: gAPI_Conversations_Stats,
        params: {
          groupId: getGroupID(),
          dateFrom: from,
          dateTo: to,
          propertyId,
        },
      });
      setConversationStatsData(res?.data);
      setIsConversationGraph(false);
    } catch (err) {
      setConversationStatsError('Failed to load conversation stats.');
      setIsConversationGraph(false);
    }
  };
  const fetchConversationStatsYear = async (from, to) => {
    try {
      setConversationStatsError(null);
      const res = await AxiosAPI({
        method: 'get',
        url: gAPI_Conversations_Stats_Year,
        params: {
          groupId: getGroupID(),
          dateFrom: startOfThisYear(),
          dateTo: today(),
          propertyId: propertyId,
        },
      });
      setConversationStatsData(res.data);
      setIsConversationGraph(false);
    } catch (err) {
      setConversationStatsError('Failed to load conversation stats.');
      setIsConversationGraph(false);
    }
  };

  const fetchAvatarClicks = async (from, to) => {
    try {
      setAvatarClicksError(null);
      const res = await AxiosAPI({
        method: 'get',
        url: gAPI_AvatarClick_Stats,
        params: {
          groupId: getGroupID(),
          dateFrom: from,
          dateTo: to,
          propertyId,
          type: 0,
        },
      });
      setAvatarClicksData(res?.data);
      setIsConversationGraph(false);
    } catch (err) {
      setAvatarClicksError('Failed to load avatar clicks.');
      setIsConversationGraph(false);
    }
  };

  const fetchChatTimeStats = async (from, to) => {
    try {
      setChatTimeStatsError(null);
      const res = await AxiosAPI({
        method: 'get',
        url: gAPI_Conversations_Time_Stats,
        params: {
          groupId: getGroupID(),
          dateFrom: from,
          dateTo: to,
          propertyId,
        },
      });
      setChatTimeStatsData(res?.data);
      setIsChatEngagement(false);
    } catch (err) {
      setChatTimeStatsError('Failed to load chat time stats.');
      setIsChatEngagement(false);
    }
  };
  const fetchChatTimeYearStats = async (from, to) => {
    try {
      setChatTimeStatsError(null);
      const res = await AxiosAPI({
        method: 'get',
        url: gAPI_Conversations_Time_Year_Stats,
        params: {
          groupId: getGroupID(),
          dateFrom: from,
          dateTo: to,
          propertyId,
        },
      });
      setChatTimeStatsData(res?.data);
      setIsChatEngagement(false);
    } catch (err) {
      setChatTimeStatsError('Failed to load chat time stats.');
      setIsChatEngagement(false);
    }
  };

  const fetchChatTimeNightStats = async (from, to) => {
    try {
      setChatTimeNightError(null);
      const res = await AxiosAPI({
        method: 'get',
        url: gAPI_Conversations_Night_Time_Stats,
        params: {
          groupId: getGroupID(),
          dateFrom: from,
          dateTo: to,
          propertyId,
        },
      });
      setChatTimeNightStatsData(res?.data);
      setIsChatEngagement(false);
    } catch (err) {
      setChatTimeNightError('Failed to load chat night time stats.');
      setIsChatEngagement(false);
    }
  };

  const fetchChatTimeNightYearStats = async (from, to) => {
    try {
      setChatTimeNightError(null);
      const res = await AxiosAPI({
        method: 'get',
        url: gAPI_Conversations_Night_Year_Time_Stats,
        params: {
          groupId: getGroupID(),
          dateFrom: from,
          dateTo: to,
          propertyId,
        },
      });
      setChatTimeNightStatsData(res?.data);
      setIsChatEngagement(false);
    } catch (err) {
      setChatTimeNightError('Failed to load chat night time stats.');
      setIsChatEngagement(false);
    }
  };

  const fetchConversationNightStats = async (from, to) => {
    try {
      setConversationNightError(null);
      const res = await AxiosAPI({
        method: 'get',
        url: gAPI_Conversations_Night_Stats,
        params: {
          groupId: getGroupID(),
          dateFrom: from,
          dateTo: to,
          propertyId,
        },
      });
      setConversationNightStatsData(res?.data);
      setIsConversationGraph(false);
    } catch (err) {
      setConversationNightError('Failed to load night conversation stats.');
      setIsConversationGraph(false);
    }
  };
  const fetchConversationNightYearStats = async (from, to) => {
    try {
      setConversationNightError(null);
      const res = await AxiosAPI({
        method: 'get',
        url: gAPI_Conversations_Night_Year_Stats,
        params: {
          groupId: getGroupID(),
          dateFrom: from,
          dateTo: to,
          propertyId,
        },
      });
      setConversationNightStatsData(res?.data);
      setIsConversationGraph(false);
    } catch (err) {
      setConversationNightError('Failed to load night conversation stats.');
      setIsConversationGraph(false);
    }
  };
  const fetchVisitorQuestions = async (from, to) => {
    try {
      setVisitorQuestionsError(null);
      const res = await AxiosAPI({
        method: 'get',
        url: gAPI_Conversations_VisitorQuestions,
        params: {
          groupId: getGroupID(),
          dateFrom: from,
          dateTo: to,
          propertyId,
          pageNumber: visitorQuestionsPageNumber,
          pageSize: visitorQuestionsPageSize,
        },
      });
      setLoading(true);
      // console.log('res1', res.data)
      setvisitorQuestions(res?.data?.messagesList);
      setAllVisitorQuestionsData(res?.data?.allMessages);
      setIsUserQuestion(false);
    } catch (err) {
      setVisitorQuestionsError('Failed to load visitor questions.');
      setIsUserQuestion(false);
    } finally {
      setLoading(false);
    }
  };

  const fetchTicketStats = async (from, to) => {
    try {
      setTicketStatsError(null);
      const res = await AxiosAPI({
        method: 'get',
        url: gAPI_TicketGroup_Stats,
        params: {
          groupId: getGroupID(),
          dateFrom: from,
          dateTo: to,
          propertyId,
        },
      });
      setLoading(true);
      setTotalTicketStats(res?.data);
      setIsTotalTicket(false);
    } catch (err) {
      setTicketStatsError('Failed to load ticket stats.');
      setIsTotalTicket(false);
    } finally {
      setLoading(false);
    }
  };

  const fetchBookingEngineSearchStats = async (from, to) => {
    try {
      setBookingSearchError(null);
      const res = await AxiosAPI({
        method: 'get',
        url: gAPI_BookingEngineSearch_Stats,
        params: {
          groupId: getGroupID(),
          dateFrom: from,
          dateTo: to,
          propertyId,
        },
      });
      setLoading(true);
      setBookingEngineSearchData(res?.data);
    } catch (err) {
      setBookingSearchError('Failed to load booking engine search stats.');
    } finally {
      setLoading(false);
    }
  };

  const fetchMessengerClickStats = async (from, to) => {
    try {
      setMessengerClicksError(null);
      const res = await AxiosAPI({
        method: 'get',
        url: gAPI_Messenger_Click,
        params: {
          groupId: getGroupID(),
          dateFrom: from,
          dateTo: to,
          propertyId,
          lang: 'en',
        },
      });
      setMessengerClickData(res?.data);
      setIsMessengerStats(false);
    } catch (err) {
      setMessengerClicksError('Failed to load messenger click stats.');
      setIsMessengerStats(false);
    }
  };

  const fetchNudgesClickStats = async (from, to) => {
    try {
      setNudgesClicksError(null);
      const res = await AxiosAPI({
        url: gAPI_Nudges_Click,
        method: 'get',
        params: {
          groupId: getGroupID(),
          propertyId,
          fromDate: from,
          toDate: to,
        },
      });
      const formattedData = Array.isArray(res?.data)
        ? res.data.map((item) => ({
          title: item.nudgeName,
          clicks: item.clickCount,
        }))
        : [];
      setNudgesClickData(formattedData);
      setIsNudgesStats(false);
      console.log('nudges click data', formattedData);
    } catch (err) {
      setNudgesClicksError('Failed to load nudges click stats.');
      setIsNudgesStats(false);
    }
  };
  const fetchMessengerVisitStats = async (from, to) => {
    try {
      setMessengerVisitStatsError(null);
      const res = await AxiosAPI({
        method: 'get',
        url: gAPI_Messenger_DateWiseStats,
        params: {
          groupId: getGroupID(),
          dateFrom: from,
          dateTo: to,
          propertyId,
        },
      });
      setMessengerVisitStatsData(res?.data);
      setIsMessengerVisitStats(false);
    } catch (err) {
      setMessengerVisitStatsError('Failed to load messenger visit stats.');
      setIsMessengerVisitStats(false);
    }
  };

  const fetchTicketByCategoryStats = async (from, to) => {
    const updatedTo = addOneDay(to);
    try {
      setTicketByCategoryError(null);
      const res = await AxiosAPI({
        method: 'get',
        url: gAPI_Ticket_Stats_ByCategory,
        params: {
          groupId: getGroupID(),
          dateFrom: from,
          dateTo: updatedTo,
          propertyId,
        },
      });
      setTicketByCategoryData(res?.data);
      setIsTicketByCategory(false);
    } catch (err) {
      setTicketByCategoryError('Failed to load ticket category stats.');
      setIsTicketByCategory(false);
    }
  };

  const combinedNumberError =
    numberStatsError ||
    ticketStatsError ||
    bookingSearchError ||
    contactError ||
    recommenderError;
  const refreshNumberCardData = () => {
    setIsChatTime(true);
    setRecommender(true);
    setContacts(true);
    setIsTotalTicket(true);
    fetchNumberStats(fromDate, toDate);
    fetchTicketStats(fromDate, toDate);
    fetchContactStats(fromDate, toDate);
    fetchRecommenderStats(fromDate, toDate);
    fetchBookingEngineSearchStats(fromDate, toDate);
  };
  const selectDateRange = async (dateFrom, dateTo, intlId, labelSet) => {
    const from = dateFrom;
    const to = dateTo;

    if (propertyId === '-1') {
      downloadSummaryAll(from, to);
    }
    setIsTopClickedUrls(true);
    fetchTopClickedUrls(from, to);
    setButtonText(<IntlMessages id={intlId} />);
    setFilterDate(false);
    setvisitorQuestionsNumber(1);
    setvisitorQuestionsPageSize(10);
    setfromDate(from);
    settoDate(to);
    setTopics(true);
    setIsCountry(false);
    setIsPercentage(true);
    setIsChatTime(true);
    setIsWebsiteVisit(false);
    setIsConversationGraph(true);
    setIsChatEngagement(true);
    setIsChatEngagement(true);
    setRecommender(true);
    setContacts(true);
    setIsTotalTicket(true);
    setIsMessengerStats(true);
    setIsNudgesStats(true);
    setIsMessengerVisitStats(true);
    setIsTicketByCategory(true);
    setIsLanguageDistribution(true);

    fetchTopicsStats(from, to);
    fetchCountriesStats(from, to);
    fetchRecommenderStats(from, to);
    fetchContactStats(from, to);
    fetchPercentageStats(from, to);
    fetchNumberStats(from, to);
    fetchAvatarClicks(from, to);
    fetchVisitorQuestions(from, to);
    fetchTicketStats(from, to);
    fetchBookingEngineSearchStats(from, to);
    fetchMessengerClickStats(from, to);
    fetchNudgesClickStats(from, to);
    fetchMessengerVisitStats(from, to);
    fetchTicketByCategoryStats(from, to);
    fetchLanguaageDistributionStats(from, to);

    if (labelSet === 'year') {
      fetchVisitorsGroupMonthStats(from, to);
      fetchConversationStatsYear(from, to);
      fetchConversationNightYearStats(from, to);
      fetchChatTimeYearStats(from, to);
      fetchChatTimeNightYearStats(from, to);
    } else {
      fetchVisitorStats(from, to);
      fetchConversationStats(from, to);
      fetchConversationNightStats(from, to);
      fetchChatTimeStats(from, to);
      fetchChatTimeNightStats(from, to);
    }
  };

  const selectLast7Days = () => {
    setLabels(last7Days);
    setSelectedDateRangeOption('last_7_days');
    selectDateRange(daysAgo7(), today(), 'dashboards.last-7-days', 'last7days');
  };

  const selectLast30Days = () => {
    setLabels(last30Days);
    setSelectedDateRangeOption('last_30_days');
    selectDateRange(
      daysAgo30(),
      today(),
      'dashboards.last-30-days',
      'last30Days'
    );
  };

  const selectLast60Days = () => {
    setLabels(last60Days);
    setSelectedDateRangeOption('last_60_days');
    selectDateRange(
      daysAgo60(),
      today(),
      'dashboards.last-60-days',
      'last60days'
    );
  };

  const selectLast90Days = () => {
    setLabels(last90Days);
    setSelectedDateRangeOption('last_90_days');
    selectDateRange(
      daysAgo90(),
      today(),
      'dashboards.last-90-days',
      'last90days'
    );
  };

  const selectThisWeek = () => {
    setLabels(week);
    setSelectedDateRangeOption('this_week');
    selectDateRange(startOfWeek(), endOfWeek(), 'dashboards.this-week', 'week');
  };

  const selectThisMonth = () => {
    setLabels(month);
    setSelectedDateRangeOption('this_month');
    selectDateRange(
      startOfMonth(),
      endOfMonth(),
      'dashboards.this-month',
      'month'
    );
  };

  const selectPreviousMonth = () => {
    setLabels(month);
    setSelectedDateRangeOption('previous_month');
    selectDateRange(
      startOfPreviousMonth(),
      endOfPreviousMonth(),
      'dashboards.previous-month',
      'month'
    );
  };

  const selectThisYear = () => {
    setLabels(year);
    setSelectedDateRangeOption('ytd');
    selectDateRange(
      startOfThisYear(),
      today(),
      'dashboards.yeartodate',
      'year'
    );
  };

  const selectLastYear = () => {
    setLabels(year);
    setSelectedDateRangeOption('last_year');
    selectDateRange(
      startOfLastYear(),
      endOfLastYear(),
      'dashboards.lastyear',
      'year'
    );
  };

  const handleFilterDateWise = (startDate, endDate) => {
    //console.log('datewise', startDate, endDate, labels)
    setvisitorQuestionsNumber(1);
    setvisitorQuestionsPageSize(10);
    setIsTopClickedUrls(true);
    fetchTopClickedUrls(startDate, endDate);
    downloadSummaryAll(startDate, endDate);
    setTopics(true);
    setIsCountry(false);
    setIsPercentage(true);
    setIsChatTime(true);
    setIsWebsiteVisit(false);
    setIsConversationGraph(true);
    setIsChatEngagement(true);
    setIsChatEngagement(true);
    setIsChatEngagement(true);
    setRecommender(true);
    setContacts(true);
    setIsTotalTicket(true);
    setIsMessengerStats(true);
    setIsNudgesStats(true);
    setIsMessengerVisitStats(true);
    setIsTicketByCategory(true);
    setIsLanguageDistribution(true);
    setfromDate(startDate);
    settoDate(endDate);

    fetchTopicsStats(startDate, endDate);
    fetchCountriesStats(startDate, endDate);
    fetchRecommenderStats(startDate, endDate);
    fetchContactStats(startDate, endDate);
    fetchPercentageStats(startDate, endDate);
    fetchNumberStats(startDate, endDate);
    fetchVisitorStats(startDate, endDate);
    fetchConversationStats(startDate, endDate);
    fetchAvatarClicks(startDate, endDate);
    fetchChatTimeStats(startDate, endDate);
    fetchChatTimeNightStats(startDate, endDate);
    fetchConversationNightStats(startDate, endDate);
    fetchVisitorQuestions(startDate, endDate);
    fetchTicketStats(startDate, endDate);
    fetchBookingEngineSearchStats(startDate, endDate);
    fetchMessengerClickStats(startDate, endDate);
    fetchNudgesClickStats(startDate, endDate);
    fetchMessengerVisitStats(startDate, endDate);
    fetchTicketByCategoryStats(startDate, endDate);
    fetchLanguaageDistributionStats(startDate, endDate);
  };

  const handleFilterMonthWise = (startDate, endDate) => {
    //console.log('monthwise', startDate, endDate, labels)
    const from = startDate;
    const to = endDate;
    if (propertyId === '-1') {
      downloadSummaryAll(from, to);
    }
    setIsTopClickedUrls(true);
    fetchTopClickedUrls(from, to);
    setLabels(year);
    setvisitorQuestionsNumber(1);
    setvisitorQuestionsPageSize(10);
    setfromDate(from);
    settoDate(to);
    setTopics(true);
    setIsCountry(false);
    setIsPercentage(true);
    setIsChatTime(true);
    setIsWebsiteVisit(false);
    setIsConversationGraph(true);
    setIsChatEngagement(true);
    setIsChatEngagement(true);
    setIsChatEngagement(true);
    setRecommender(true);
    setContacts(true);
    setIsTotalTicket(true);
    setIsMessengerStats(true);
    setIsNudgesStats(true);
    setIsMessengerVisitStats(true);
    setIsTicketByCategory(true);
    setIsLanguageDistribution(true);

    fetchTopicsStats(from, to);
    fetchCountriesStats(from, to);
    fetchRecommenderStats(from, to);
    fetchContactStats(from, to);
    fetchPercentageStats(from, to);
    fetchNumberStats(from, to);
    fetchAvatarClicks(from, to);
    fetchVisitorQuestions(from, to);
    fetchTicketStats(from, to);
    fetchBookingEngineSearchStats(from, to);
    fetchMessengerClickStats(from, to);
    fetchNudgesClickStats(from, to);
    fetchMessengerVisitStats(from, to);
    fetchTicketByCategoryStats(from, to);
    fetchVisitorsGroupMonthStats(from, to);
    fetchConversationStatsYear(from, to);
    fetchConversationNightYearStats(from, to);
    fetchChatTimeYearStats(from, to);
    fetchChatTimeNightYearStats(from, to);
    fetchLanguaageDistributionStats(from, to);
  };

  const handleFilter = () => {
    let diff = moment(endDate).diff(startDate, 'days');
    setButtonText('Date Range');
    setSelectedDateRangeOption('custom_range');
    if (diff > 365) {
      setMessage('The start and end date must be within a year of each other.');
      setError(true);
      return;
    }
    if (diff > 90) {
      setIsShow(false);
      setLabels(year);
      handleFilterMonthWise(
        moment(startDate).format('YYYY-MM-DD 00:00:00'),
        moment(endDate).format('YYYY-MM-DD') + ' 23:59:59'
      );
      setFilterDate(true);
    } else {
      if (diff >= 60) setLabels(LastDays(startDate, endDate));
      else if (diff >= 30) setLabels(LastDays(startDate, endDate));
      else if (diff >= 7) setLabels(LastDays(startDate, endDate));
      else setLabels(LastDays(startDate, endDate));
      setIsShow(false);
      handleFilterDateWise(
        moment(startDate).format('YYYY-MM-DD 00:00:00'),
        moment(endDate).format('YYYY-MM-DD') + ' 23:59:59'
      );
      setFilterDate(true);
    }
  };
  if (Array.isArray(domains) && isBusinessOperator === false) {
    domains.forEach((r) => {
      if (r.type === 'BusinessOperator') {
        setIsBusinessOperator(true);
      }
    });
  }
  if (Array.isArray(domains) && isUtilityProvider === false) {
    domains.forEach((r) => {
      if (r.type === 'UtilityProviders') {
        setIsUtilityProvider(true);
      }
    });
  }
  const downloadSummaryAll = (datefrom, dateto) => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_AllPropertyStatsSummary}`,
      params: {
        groupId: getGroupID(),
        dateFrom: datefrom,
        dateTo: dateto,
      },
    }).then((res) => {
      var tablePrint = [
        {
          r1: 'Start Date :' + datefrom,
          r2: '',
          r3: 'End Date :' + dateto,
          r4: '',
          r5: '',
          r6: '',
          r7: '',
          r8: '',
          r9: '',
          r10: '',
          r11: '',
          r12: '',
          r13: '',
          r14: '',
          r15: '',
          r16: '',
          r17: '',
          r18: '',
          r19: '',
          r20: ''
        },
        {},
        {
          r1: 'Property',
          r2: 'Estimated Time Saving (Hours)',
          r3: 'Estimated Time Saving (NZD)',
          r4: 'Avatar Clicks',
          r5: 'Total Conversations',
          r6: 'Total User Messages',
          r7: 'Website Conversations',
          r8: 'WhatsApp Conversations',
          r9: 'Facebook Conversations',
          r10: 'Insta Conversations',
          r11: 'Tickets',
          r12: 'Contact',
          r13: 'Consented Contacts',
          r14: 'Booking Engine Leads',
          r15: 'Room Nights Referred',
          r16: 'Room Revenue Referred (NZD)',
          r17: 'Room Revenue Referred (USD)',
          r18: 'Website Visits by Country',
          r19: 'Popular Menu Items',
          r20: 'Recent Queries'
        },
      ];
      if (res.data.length > 0 && res.data.length > 0) {
        res.data.map((elem) => {
          tablePrint.push({
            r1: elem.propertyName,
            r2: elem.estimateTimeSavingHours,
            r3: elem.estimateTimeSavingNZD,
            r4: elem.totalAvatarClicks,
            r5: elem.totalConversations,
            r6: elem.totalUsersMessages,
            r7: elem.websiteConversations,
            r8: elem.whatsAppConversations,
            r9: elem.facebookConversations,
            r10: elem.instagramConversations,
            r11: elem.tickets,
            r12: elem.contacts,
            r13: elem.consentsContacts,
            r14: elem.bookingEngineLeads,
            r15: elem.roomNightsReferred,
            r16: elem.roomsRevenueReferredNZD,
            r17: elem.roomsRevenueReferredUSD,
            r18: elem.websiteCountryVisit,
            r19: elem.menuItemClick,
            r20: elem.recentQuery,
          });
        });
      }
      setCSVData(tablePrint);
    });
  };
  //console.log('label', labels);
  const dateRangeOptions = [
    {
      value: 'last_7_days',
      label: intl.formatMessage({ id: 'dashboards.last-7-days' }),
      onSelect: selectLast7Days,
    },
    {
      value: 'last_30_days',
      label: intl.formatMessage({ id: 'dashboards.last-30-days' }),
      onSelect: selectLast30Days,
    },
    {
      value: 'last_60_days',
      label: intl.formatMessage({ id: 'dashboards.last-60-days' }),
      onSelect: selectLast60Days,
    },
    {
      value: 'last_90_days',
      label: intl.formatMessage({ id: 'dashboards.last-90-days' }),
      onSelect: selectLast90Days,
    },
    {
      value: 'this_week',
      label: intl.formatMessage({ id: 'dashboards.this-week' }),
      onSelect: selectThisWeek,
    },
    {
      value: 'this_month',
      label: intl.formatMessage({ id: 'dashboards.this-month' }),
      onSelect: selectThisMonth,
    },
    {
      value: 'previous_month',
      label: intl.formatMessage({ id: 'dashboards.previous-month' }),
      onSelect: selectPreviousMonth,
    },
    {
      value: 'ytd',
      label: intl.formatMessage({ id: 'dashboards.yeartodate' }),
      onSelect: selectThisYear,
    },
    {
      value: 'last_year',
      label: intl.formatMessage({ id: 'dashboards.lastyear' }),
      onSelect: selectLastYear,
    },
    {
      value: 'custom_range',
      label: intl.formatMessage({ id: 'form-components.date-range' }),
      onSelect: () => setIsShow(!isShow),
    },
  ];

  const selectedDateRange =
    dateRangeOptions.find(
      (option) => option.value === selectedDateRangeOption
    ) || dateRangeOptions[0];

  const handleDateRangeChange = (option) => {
    if (!option) {
      return;
    }
    setSelectedDateRangeOption(option.value);
    option.onSelect();
  };

  return (
    <Fragment>
      <Row>
        <Col xxs="12" className="mb-2">
          <Fragment>
            {filterDate === true && (
              <div className="float-left mt-2">
                <span className="mr-2">
                  <b>From : </b>
                  {moment(startDate).format('DD')}/
                  {moment(startDate).format('MM')}/
                  {moment(startDate).format('YYYY')}
                </span>
                <span className="ml-2">
                  <b>To : </b>
                  {moment(endDate).format('DD')}/{moment(endDate).format('MM')}/
                  {moment(endDate).format('YYYY')}
                </span>
              </div>
            )}
            <div className="btn-group float-right float-none-xs mb-3">
              {propertyId === '-1' && (
                <CSVLink
                  data={csvData}
                  headers={[
                    { key: 'r1', label: '' },
                    { key: 'r2', label: '' },
                    { key: 'r3', label: '' },
                    { key: 'r4', label: '' },
                    { key: 'r5', label: '' },
                    { key: 'r6', label: '' },
                    { key: 'r7', label: '' },
                    { key: 'r8', label: '' },
                    { key: 'r9', label: '' },
                    { key: 'r10', label: '' },
                    { key: 'r11', label: '' },
                    { key: 'r12', label: '' },
                    { key: 'r13', label: '' },
                    { key: 'r14', label: '' },
                    { key: 'r15', label: '' },
                    { key: 'r16', label: '' },
                    { key: 'r17', label: '' },
                    { key: 'r18', label: '' },
                    { key: 'r19', label: '' },
                    { key: 'r20', label: '' },
                  ]}
                  filename="summary-stats.csv"
                >
                  <Button color="primary" outline size="xs" className="mr-2">
                    Download Summary
                  </Button>
                </CSVLink>
              )}
              <SubscribeToReports />
              <div style={{ minWidth: 168 }}>
                <Select
                  options={dateRangeOptions}
                  value={selectedDateRange}
                  placeholder={buttonText}
                  onChange={handleDateRangeChange}
                  styles={compactFilterSelectStyles}
                  compactHeight={28}
                  compactWidth="168px"
                  isSearchable={false}
                  menuPlacement="auto"
                  menuShouldScrollIntoView={false}
                />
              </div>
            </div>
          </Fragment>
        </Col>
      </Row>
      <Row>
        {!isVoucherEngine || domains.length > 1 ? (
          <Col sm="12" md="12" className="mb-4">
            <StatContainer
              error={numberStatsError}
              onRefresh={() => fetchNumberStats(fromDate, toDate)}
            >
              {isChatTime ? (
                <div className="text-center loading" />
              ) : (
                <Fragment>
                  <NumberTotalConversation
                    history={history}
                    numbertimedata={numberStatsData}
                    fromDate={fromDate}
                    toDate={toDate}
                    messengerAvatar={
                      isMessengerConnect ? messengerClickData.avatarClick : null
                    }
                    groupId={getGroupID()}
                    totalClicks={totalClicks}
                  />
                </Fragment>
              )}
            </StatContainer>
          </Col>
        ) : (
          ''
        )}
        <Col sm="12" md="6" className="mb-4">
          <StatContainer
            error={visitorStatsError}
            onRefresh={() => fetchVisitorStats(fromDate, toDate)}
          >
            {isWebsiteVisit ? (
              <div className="text-center">
                <div className="text-center loading" />
              </div>
            ) : (
              <WebsiteVisitsChartCard
                labels={labels}
                visitorStatsData={visitorStatsData}
              />
              // <p style={{ textAlign: 'center' }}>Temporarily Unavailable</p>
            )}
          </StatContainer>
        </Col>
        {!isVoucherEngine || domains.length > 1 ? (
          <Col sm="12" md="6" className="mb-4">
            <StatContainer
              error={conversationStatsError}
              onRefresh={() => fetchConversationStats(fromDate, toDate)}
            >
              {isConversationGraph ? (
                <div className="text-center loading" />
              ) : (
                <ConservationsChartCard
                  labels={labels}
                  conversationStatsData={conversationStatsData}
                  conversationNightStatsData={conversationNightStatsData}
                  fromDate={fromDate}
                  toDate={toDate}
                  chattimeStatsData={chattimeStatsData}
                  chattimeNightStatsData={chattimeNightStatsData}
                  visitorStatsData={visitorStatsData}
                  avatarclickdata={avatarClicksData}
                />
              )}
            </StatContainer>
          </Col>
        ) : (
          ''
        )}

        {!isVoucherEngine || domains.length > 1 ? (
          <Col sm="12" md="12">
            <StatContainer
              error={percentageError}
              onRefresh={() => fetchPercentageStats(fromDate, toDate)}
            >
              {isPercentage ? (
                <div className="text-center loading" />
              ) : (
                <Fragment>
                  <Percentage data={percentageStatsData} />
                </Fragment>
              )}
            </StatContainer>
          </Col>
        ) : (
          ''
        )}

        {!isVoucherEngine || domains.length > 1 ? (
          <Col sm="12" md="6" className="mb-4">
            <StatContainer
              error={countriesError}
              onRefresh={() => fetchCountriesStats(fromDate, toDate)}
            >
              {isCountry ? (
                <div className="text-center loading" />
              ) : (
                <Country
                  labels={countryDataTableColumns}
                  data={countriesStatsData}
                  fromDate={fromDate}
                  toDate={toDate}
                />
                // <p style={{ textAlign: 'center' }}>Temporarily Unavailable</p>
              )}
            </StatContainer>
          </Col>
        ) : (
          ''
        )}
        {!isVoucherEngine || domains.length > 1 ? (
          <Col sm="12" md="6" className="mb-4">
            <StatContainer
              error={chatTimeStatsError}
              onRefresh={() => fetchChatTimeStats(fromDate, toDate)}
            >
              {isChatEngagement ? (
                <div className="text-center loading" />
              ) : (
                <ChatTimeChartCard
                  labels={labels}
                  chattimeStatsData={chattimeStatsData}
                  chattimeNightStatsData={chattimeNightStatsData}
                  fromDate={fromDate}
                  toDate={toDate}
                />
              )}
            </StatContainer>
          </Col>
        ) : (
          ''
        )}
        {!isVoucherEngine || domains.length > 1 ? (
          <Col sm="12" md="6" className="mb-4">
            <StatContainer
              error={topicsError}
              onRefresh={() => fetchTopicsStats(fromDate, toDate)}
            >
              {isTopics ? (
                <div className="text-center loading" />
              ) : (
                <Topic
                  labels={
                    propertyData?.analyzeTicket === true
                      ? dataTableColumnsAnalyze
                      : dataTableColumns
                  }
                  data={topicsStatsData}
                  fromDate={fromDate}
                  toDate={toDate}
                  analyzeTicket={propertyData?.analyzeTicket}
                />
              )}
            </StatContainer>
          </Col>
        ) : (
          ''
        )}

        {!isVoucherEngine || domains.length > 1 ? (
          isUtilityProvider === false && isBusinessOperator === false ? (
            <Col sm="12" md="6" className="mb-4">
              <StatContainer
                error={recommenderError}
                onRefresh={() => fetchRecommenderStats(fromDate, toDate)}
              >
                {isRecommender ? (
                  <div className="text-center">
                    <div className="text-center loading" />
                  </div>
                ) : (
                  <Recommender
                    labels={dataTableRecommenderColumns}
                    data={recommenderStatsData}
                    fromDate={fromDate}
                    toDate={toDate}
                  />
                )}
              </StatContainer>
            </Col>
          ) : (
            ''
          )
        ) : (
          ''
        )}
        {!isVoucherEngine || domains.length > 1
          ? isMessengerConnect &&
          !hideWebwidgetStats && (
            <Col sm="12" md="6" className="mb-4">
              <StatContainer
                error={messengerClicksError}
                onRefresh={() => fetchMessengerClickStats(fromDate, toDate)}
              >
                {isMessengerStats ? (
                  <div className="text-center">
                    <div className="text-center loading" />
                  </div>
                ) : (
                  <MessengerClickStats
                    labels={dataTableMessengerColumns}
                    data={
                      messengerClickData.itemClicks === null
                        ? []
                        : messengerClickData.itemClicks
                    }
                    fromDate={fromDate}
                    toDate={toDate}
                  />
                )}
              </StatContainer>
            </Col>
          )
          : ''}
        {!isVoucherEngine || domains.length > 1 ? (
          <Col sm="12" md="6" className="mb-4">
            <StatContainer
              error={visitorQuestionsError}
              onRefresh={() => fetchVisitorQuestions(fromDate, toDate)}
            >
              {isUserQuestion ? (
                <div className="text-center loading" />
              ) : (
                <UserQuestions
                  allData={allVisitorQuestionsData}
                  data={visitorQuestionsData}
                  isloading={isloading}
                  loadMore={loadMore}
                  fromDate={fromDate}
                  toDate={toDate}
                />
              )}
            </StatContainer>
          </Col>
        ) : (
          ''
        )}
        {!isVoucherEngine || domains.length > 1
          ? isMessengerConnect &&
          !hideWebwidgetStats && (
            <Col sm="12" md="6" className="mb-4">
              <StatContainer
                error={messengerVisitStatsError}
                onRefresh={() => fetchMessengerVisitStats(fromDate, toDate)}
              >
                {isMessengerVisitStats ? (
                  <div className="text-center loading" />
                ) : (
                  <MessengerVisitsChartCard
                    labels={labels}
                    data={messengerVisitStatsData}
                    fromDate={fromDate}
                    toDate={toDate}
                  />
                )}
              </StatContainer>
            </Col>
          )
          : ''}

        {!isVoucherEngine || domains.length > 1 ? (
          <Col sm="12" md="6" className="mb-4">
            <StatContainer
              error={ticketByCategoryError}
              onRefresh={() => fetchTicketByCategoryStats(fromDate, toDate)}
            >
              {isTicketByCategory ? (
                <div className="text-center loading" />
              ) : (
                <TicketStatsByCategory
                  labels={dataTableTicketByCategoryColumns}
                  data={ticketByCategoryData}
                  fromDate={fromDate}
                  toDate={toDate}
                />
              )}
            </StatContainer>
          </Col>
        ) : (
          ''
        )}
        {!isVoucherEngine || domains.length > 1
          ? isMessengerConnect &&
          !hideWebwidgetStats && (
            <Col sm="12" md="6" className="mb-4">
              <StatContainer
                error={topClickedUrlsError}
                onRefresh={() => fetchTopClickedUrls(fromDate, toDate)}
              >
                {isTopClickedUrls ? (
                  <div className="text-center loading" />
                ) : (
                  <TopClickedUrls
                    labels={dataTableTopClickedUrlsColumns}
                    data={topClickedUrlsData}
                    fromDate={fromDate}
                    toDate={toDate}
                  />
                )}
              </StatContainer>
            </Col>
          )
          : ''}
        {!isVoucherEngine || domains.length > 1 ? (
          <Col sm="12" md="6" className="mb-4">
            <StatContainer
              error={languageDistributionError}
              onRefresh={() =>
                fetchLanguaageDistributionStats(fromDate, toDate)
              }
            >
              {isLanguageDistribution ? (
                <div className="text-center loading" />
              ) : (
                <LanguageDistributionStats data={languageDistribution} />
              )}
            </StatContainer>
          </Col>
        ) : (
          ''
        )}

        {!isVoucherEngine || domains.length > 1
          ? isMessengerConnect &&
          !hideWebwidgetStats && (
            <Col sm="12" md="6" className="mb-4">
              <StatContainer
                error={nudgesClicksError}
                onRefresh={() => fetchNudgesClickStats(fromDate, toDate)}
              >
                {isNudgesStats ? (
                  <div className="text-center">
                    <div className="text-center loading" />
                  </div>
                ) : (
                  <NudgesClickStats
                    labels={dataTableNudgesColumns}
                    data={nudgesClickData}
                    propertyId={propertyId}
                    fromDate={fromDate}
                    toDate={toDate}
                  />
                )}
              </StatContainer>
            </Col>
          )
          : ''}

        {!isVoucherEngine || domains.length > 1 ? (
          <Col sm="12" md="12">
            <StatContainer
              error={numberStatsError}
              onRefresh={() => fetchNumberStats(fromDate, toDate)}
            >
              {isChatTime ? (
                <div className="text-center loading" />
              ) : (
                <Fragment>
                  <Number
                    bookingCsvData={bookingCsvData}
                    numbertimedata={numberStatsData}
                    messengerAvatar={
                      isMessengerConnect ? messengerClickData.avatarClick : null
                    }
                    propertyData={propertyData}
                    isBusinessOperator={isBusinessOperator}
                    isUtilityProvider={isUtilityProvider}
                  />
                </Fragment>
              )}
            </StatContainer>
          </Col>
        ) : (
          ''
        )}

        {!isVoucherEngine || domains.length > 1 ? (
          <Col sm="12" md="12">
            <StatContainer
              error={combinedNumberError}
              onRefresh={refreshNumberCardData}
            >
              {isChatTime || isTotalTicket ? (
                <div className="text-center loading" />
              ) : (
                <Number
                  bookingCsvData={bookingCsvData}
                  history={history}
                  numberdata={numberStatsData}
                  totalTicketStats={totalTicketStats}
                  bookingEngineStats={recommenderStatsData}
                  fromDate={fromDate}
                  toDate={toDate}
                  isBookingEngineConnect={isBookingEngineConnect}
                  bookingEngineSearchData={bookingEngineSearchData}
                  contactStatsData={contactStatsData}
                  isBusinessOperator={isBusinessOperator}
                  isUtilityProvider={isUtilityProvider}
                  propertyData={propertyData}
                  propertyId={propertyId}
                />
              )}
            </StatContainer>
          </Col>
        ) : (
          ''
        )}
        <Col sm="12" md="12" className="mb-4">
          <StatContainer
            error={contactError}
            onRefresh={() => fetchContactStats(fromDate, toDate)}
          >
            {isContact ? (
              <div className="text-center">
                <div className="text-center loading" />
              </div>
            ) : (
              <Contact
                labels={dataTableColumnsContacts}
                data={contactStatsData}
                timeZone={timeZone}
                propertyId={propertyId}
                isMasked={isMasked}
              />
            )}
          </StatContainer>
        </Col>
      </Row>

      <Modal
        isOpen={isShow}
        toggle={() => setIsShow(!isShow)}
        style={{ borderRadius: '10px' }}
      >
        <ModalHeader toggle={() => setIsShow(!isShow)}>
          {' '}
          <IntlMessages id="form-components.date-range" />
        </ModalHeader>
        <ModalBody>
          <Row>
            <Colxx md="6" className="mb-2">
              <FormGroup>
                <Label>
                  <IntlMessages id="dashboards.start-date" />
                </Label>
                <DatePicker
                  style={{ borderRadius: '10px' }}
                  selected={startDate ? new Date(startDate) : null} // ensure Date object
                  onChange={handleStartDate}
                  placeholderText="Start Date"
                  dateFormat="dd/MM/yyyy" // ✅ correct format
                />
              </FormGroup>
            </Colxx>

            <Colxx md="6" className="mb-2">
              <FormGroup>
                <Label>
                  {' '}
                  <IntlMessages id="dashboards.end-date" />
                </Label>
                <DatePicker
                  style={{ borderRadius: '10px' }}
                  selected={endDate ? new Date(endDate) : null} // ✅ always Date object
                  onChange={handleEndDate}
                  placeholderText="End Date"
                  dateFormat="dd/MM/yyyy" // ✅ correct format
                />
              </FormGroup>
            </Colxx>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => handleFilter()}>
            Submit
          </Button>
          <Button className="ml-2" onClick={() => setIsShow(!isShow)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={isError}
        toggle={() => setError(!isError)}
        style={{ borderRadius: '10px' }}
      >
        <ModalHeader toggle={() => setError(!isError)}>BOOKMEBOB</ModalHeader>
        <ModalBody>
          <Row>
            <p className="m-2">{message}</p>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button className="ml-2" onClick={() => setError(!isError)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}
export default injectIntl(ChartCard);
